import VideoIcon from '@atlaskit/icon/core/video';
import * as React from 'react';

export function SvgVideoCam() {
  return <VideoIcon label="" testId="ads-refreshed-icon" />;
}
